<template>
  <w-dialog ref="dialogRef" :title="tvmTitle" width="650px" :before-close="handleClose" @wConfirm="handleSave"
    class="config-dialog">
    <div class="dialog-content">
      <!-- 首页广告 -->
      <div class="section">
        <div class="section-title">
          <i class="section-icon"></i>
          首页广告 <span class="section-tip">(建议视频尺寸1920x1080)</span>
        </div>

        <img-upload :fileList="formData.homeAds" type="video" @uploadFile="uploadHomeAds" @deleteFile="deleteHomeAds"
          :limit="3" />
      </div>

      <!-- 宣传广告 -->
      <div class="section">
        <div class="section-title">
          <i class="section-icon"></i>
          宣传广告 <span class="section-tip">(建议视频尺寸1920x1080)</span>
        </div>

        <img-upload :fileList="formData.promoAds" type="video" @uploadFile="uploadPromoAds" @deleteFile="deletePromoAds"
          :limit="6" />
      </div>

      <!-- 一键查询 -->
      <div class="section">
        <div class="section-title">
          <i class="section-icon"></i>
          一键查询
        </div>

        <div class="query-form">
          <!-- 景区服务电话 -->
          <div class="form-item">
            <div class="form-label">
              <span class="required">*</span> 景区服务电话
            </div>
            <el-input v-model="formData.scenicPhone" placeholder="请输入"></el-input>
          </div>

          <!-- 酒店咨询电话 -->
          <div class="form-item">
            <div class="form-label">
              <span class="required">*</span> 酒店咨询电话
            </div>
            <div class="full-width">
              <el-input v-model="formData.hotelPhone" placeholder="请输入"></el-input>
            </div>
          </div>

          <!-- 公众号信息 -->
          <div class="form-item full-width">
            <div class="form-label">
              <span class="required">*</span> 公众号信息 <span class="section-tip">(建议图片尺寸400x400px)</span>
            </div>
            <div class="qrcode-upload">
              <img-upload :fileList="wxQrcode" suggestText="" @uploadFile="uploadQrcode" @deleteFile="deleteQrcode" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </w-dialog>
</template>

<script setup>
import { ref, reactive, } from 'vue';
import { ElMessage, ElLoading } from 'element-plus';
import ImgUpload from '@/components/img-upload/img-upload.vue';
import { useStore } from 'vuex';
import { BasicApi } from '@/plugins/api';

const getConfig = (tvm_id) => {
  BasicApi.tvmGetConfig({
    tvm_id: tvm_id
  }).then((res) => {
    // sft_id : 16 自助购票机首页广告 17 自助购票机宣传广告 18 自助购票机公众号图片
    if (res.Code === 200) {
      res.Data.files.forEach(item => {
        if (item.sft_id === 16) {
          formData.homeAds = item.files;
        } else if (item.sft_id === 17) {
          formData.promoAds = item.files;
        } else if (item.sft_id === 18) {
          wxQrcode.value = item.files;
        }
      });
      formData.scenicPhone = res.Data.tvm_scenic_hotline || '';
      formData.hotelPhone = res.Data.tvm_hotel_hotline || '';
    }
  })
};



const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  configData: {
    type: Object,
    default: () => ({})
  }
});
const wxQrcode = ref([]);

const store = useStore();
store.dispatch('getQiniuData');

const tvmTitle = ref('配置');
const dialogRef = ref(null);
const tvmId = ref(0);
const show = (row) => {
  tvmTitle.value = '配置' + row.tvm_name;
  tvmId.value = row.tvm_id;
  getConfig(row.tvm_id);
  dialogRef.value.show();
};
const emit = defineEmits(['update:visible', 'save']);

const dialogVisible = ref(props.visible);
const formData = reactive({
  homeAds: [],
  promoAds: [],
  scenicPhone: '',
  hotelPhone: '',
  qrcode: [],
  homeVideoUrl: ''
});

/**
   * 
   * 首页广告文件上传
   * 
   * **/
const uploadHomeAds = (data) => {
  const files = []
  files.push(data.key)
  const addData = {
    sft_id: 16,
    tvm_id: tvmId.value,
    file_type: 2,
    files: files
  }
  BasicApi.tvmAddFile(addData).then((res) => {
    if (res.Code === 200) {
      ElMessage.success('上传成功');
      formData.homeAds.push({ file_url: data.standard_url, key: data.key });
    }
  })
};
/**
 * 
 * 首页广告文件删除
 * 
 * **/
const deleteHomeAds = (data) => {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: '删除中...'
  });

  BasicApi.tvmDelFile({
    sf_id: data.sf_id,
    sft_id: 16
  }).then((res) => {
    if (res.Code === 200) {
      loadingInstance.close();
      ElMessage.success('删除成功');
      let index1 = formData.homeAds.findIndex((item) => item.key === data.key);
      formData.homeAds.splice(index1, 1);
    }
  })
};
/**
 * 
 * 宣传广告文件上传
 * 
 **/
const uploadPromoAds = (data) => {
  const files = []
  files.push(data.key)
  const addData = {
    sft_id: 17,
    tvm_id: tvmId.value,
    file_type: 2,
    files: files
  }
  BasicApi.tvmAddFile(addData).then((res) => {
    if (res.Code === 200) {
      ElMessage.success('上传成功');
      formData.promoAds.push({ file_url: data.standard_url, key: data.key });
    }
  })
};
/**
 * 
 * 宣传广告文件删除
 * 
 * **/
const deletePromoAds = (data) => {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: '删除中...'
  });
  BasicApi.tvmDelFile({
    sf_id: data.sf_id,
    sft_id: 17
  }).then((res) => {
    if (res.Code === 200) {
      loadingInstance.close();
      ElMessage.success('删除成功');
      let index1 = formData.promoAds.findIndex((item) => item.key === data.key);
      formData.promoAds.splice(index1, 1);
    }
  })
};
/**
 * 
 * 公众号二维码文件上传
 * 
 * **/
const uploadQrcode = (data) => {
  wxQrcode.value.push({ file_url: data.standard_url, key: data.key });
  const files = []
  files.push(data.key)
  const addData = {
    sft_id: 18,
    tvm_id: tvmId.value,
    file_type: 1,
    files: files
  }
  BasicApi.tvmAddFile(addData).then((res) => {
    if (res.Code === 200) {
      ElMessage.success('上传成功');
    }
  })
};
/**
 * 
 * 公众号二维码文件删除
 * 
 * **/
const deleteQrcode = (data) => {
  BasicApi.tvmDelFile({
    sf_id: data.sf_id,
    sft_id: 18
  }).then((res) => {
    if (res.Code === 200) {
      ElMessage.success('删除成功');
      const index1 = wxQrcode.value.findIndex((item) => item.key === data.key);
      wxQrcode.value.splice(index1, 1);
    }
  })
};




// 关闭弹窗
const handleClose = () => {
  dialogVisible.value = false;
};


// 保存配置
const handleSave = () => {
 
  // 表单验证
  if (!formData.scenicPhone) {
    ElMessage.warning('请输入景区服务电话');
    return;
  }

  if (!formData.hotelPhone) {
    ElMessage.warning('请选择酒店咨询电话');
    return;
  }

  // 提交数据到服务器
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: '保存中...'
  });

  BasicApi.tvmSetConfig({
    tvm_id: tvmId.value,
    tvm_scenic_hotline: formData.scenicPhone,
    tvm_hotel_hotline: formData.hotelPhone
  }).then(res => {
    loadingInstance.close();
    if (res.Code === 200) {
      ElMessage.success('配置保存成功');
      dialogRef.value.close();
    } else {
      ElMessage.error(res.Message || '保存失败');
    }
  })
};



defineExpose({
  show
})
</script>

<style lang="scss" scoped>
.config-dialog {
  :deep(.el-dialog__header) {
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
  }

  :deep(.el-dialog__body) {
    padding: 20px;
  }

  :deep(.el-dialog__footer) {
    padding: 10px 20px 20px;
  }

  :deep(.dialog-content) {
    max-height: 60vh;
    overflow-y: auto;
  }

  :deep(.section) {
    margin-bottom: 20px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      display: flex;
      align-items: center;

      .section-icon {
        width: 4px;
        height: 16px;
        background-color: #409EFF;
        margin-right: 8px;
        display: inline-block;
      }

      .section-tip {
        font-size: 12px;
        color: #ff0000;
        font-weight: normal;
        margin-left: 5px;
      }
    }
  }

  :deep(.upload-area) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  :deep(.upload-item) {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;

    .upload-btn {
      width: 100%;
      height: 100%;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }
    }

    .preview-container {
      width: 100%;
      height: 100%;
      position: relative;

      .preview-media {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }

      .delete-btn {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 20px;
        height: 20px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 0 0 0 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .el-icon {
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }

  :deep(.query-form) {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    .form-item {
      width: calc(50% - 8px);

      &.full-width {
        width: 100%;
      }

      .form-label {
        margin-bottom: 8px;
        font-size: 14px;

        .required {
          color: #f56c6c;
          margin-right: 4px;
        }
      }
    }
  }

  :deep(.qrcode-upload) {
    width: 100px;
    height: 100px;

    .upload-btn {
      width: 100%;
      height: 100%;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }

      .el-icon {
        font-size: 24px;
        color: #8c8c8c;
      }
    }

    .qrcode-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  :deep(.dialog-footer) {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
  }
}

.el-dialog .el-dialog__footer .el-button {
  text-align: center;
  padding: 0 !important;
}
</style>